import UpcomingAppointmentsContainer from './UpcomingAppointmentsContainer';

export default UpcomingAppointmentsContainer;



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/UpcomingAppointments/index.js